import { ReactElement, ReactNode } from 'react';
import { Heading } from '@digdir/designsystemet-react';
import classes from '../WorkEnvironmentFormSubmission.module.css';

type Props = {
  tone: 'success' | 'neutral' | 'warning';
  icon: ReactElement;
  title: string;
  children: ReactNode;
};

export const SurveyMessage = ({ tone, icon, title, children }: Props): ReactElement => (
  <div className={classes.done}>
    <span className={classes.doneMark} data-tone={tone}>
      {icon}
    </span>
    <Heading level={1} data-size="lg">
      {title}
    </Heading>
    {children}
  </div>
);
